import { useQuery } from "@tanstack/react-query";

import { QUERY_KEYS } from "../constants";
import useAuth from "../../hooks/useAuth";
import { getUserVerificationStatus } from "../../api-clients/complianceKycsClient";
import { useCallback, useEffect, useState } from "react";
import { isUpToLegalAge } from "../../utils/helpers";

type CheckIsLegalAgeParams = {
  dob?: string;
  checkDobArgFirst?: boolean;
};

function useUserVerificationStatusQuery() {
  const { isLoggedIn, userProfile } = useAuth();
  const [isLegalAge, setIsLegalAge] = useState<boolean>();

  const query = useQuery({
    queryKey: [QUERY_KEYS.USER.VERIFICATION_STATUS],
    queryFn: getUserVerificationStatus,
    enabled: isLoggedIn,
  });

  const checkIsLegalAge = useCallback(
    (params?: CheckIsLegalAgeParams) => {
      const { dob = userProfile?.dob, checkDobArgFirst = false } = params ?? {};

      if (!query.data?.dob && !dob) return;
      if (checkDobArgFirst) {
        return dob ? isUpToLegalAge(dob) : query.data?.isLegalAge;
      }
      return query.data?.dob ? query.data.isLegalAge : isUpToLegalAge(dob);
    },
    [userProfile?.dob, query.data]
  );

  useEffect(() => {
    if (!query.isSuccess) return;
    const legalAgeStatus = checkIsLegalAge();
    setIsLegalAge(legalAgeStatus);
  }, [query.isSuccess, checkIsLegalAge]);

  return {
    query,
    isLegalAge,
    checkIsLegalAge,
    userVerificationData: query.data,
    userVerificationIsLoading: query.isLoading,
  };
}

export default useUserVerificationStatusQuery;
